import { Reducer } from 'redux';
import { IAction } from '../types';
import { categoryListJson, tagsJson } from '@/components/ElectronLayout/server';
import LocalStore from '@/utils/store';

export interface searchHistroyListJson {
  name: string;
}

export interface LiveHeadInfoState {
  breadCrumbState: number;
  searchHistroyList: searchHistroyListJson[];
  categoryList: categoryListJson[];
  title: string;
  limit: string;
  tagList: tagsJson[];
  tag_id: string | number;
}

const localGameInfo = LocalStore.getValue<LiveHeadInfoState>('LIVE_HEAD_STATE') || {};

export const liveHeadInfo: LiveHeadInfoState = {
  breadCrumbState: 0,
  searchHistroyList: [],
  categoryList: [],
  title: '',
  limit: '',
  tagList: [],
  tag_id: '',
  ...localGameInfo
};

export const setLiveHeadInfo: (payload: LiveHeadInfoState) => IAction<LiveHeadInfoState> = (
  payload: LiveHeadInfoState
) => ({
  type: 'setLiveHeadInfo',
  payload
});

const liveReducer: Reducer<LiveHeadInfoState, IAction<any>> = (state = liveHeadInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setLiveHeadInfo':
      LocalStore.setValue('LIVE_HEAD_STATE', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default liveReducer;
